import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { QrCode, Loader2, Clock, Building2 } from "lucide-react";

export default function VisitorLogs() {
  const [passes, setPasses] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    api.get("/visitor-passes").then(({ data }) => setPasses(data)).catch((e) => console.error(e)).finally(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="grid place-items-center py-20 text-teal-400"><Loader2 className="w-8 h-8 animate-spin" /></div>;

  const isExpired = (p) => new Date(p.expires_at) < new Date();

  return (
    <div>
      <div className="mb-8"><h1 className="text-2xl sm:text-3xl font-extrabold text-[#0B3B39]">Visitor Gate Passes</h1><p className="text-slate-600 mt-1">{passes.length} passes issued • security log monitor.</p></div>
      {passes.length === 0 ? (
        <div className="oj-card p-12 text-center text-slate-500"><QrCode className="w-10 h-10 mx-auto mb-3 opacity-50" />No visitor passes issued yet.</div>
      ) : (
        <div className="oj-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="border-b border-teal-900/50 text-left text-xs font-mono uppercase tracking-wider text-slate-500">
                <th className="px-5 py-3">Pass Code</th><th className="px-5 py-3">Visitor</th><th className="px-5 py-3 hidden sm:table-cell">Host</th><th className="px-5 py-3 hidden md:table-cell">Issued</th><th className="px-5 py-3">Status</th>
              </tr></thead>
              <tbody>
                {passes.map((p) => (
                  <tr key={p.id} className="border-b border-teal-900/30 last:border-0" data-testid={`visitor-pass-row-${p.id}`}>
                    <td className="px-5 py-3.5 font-mono font-semibold text-amber-300">{p.pass_code}</td>
                    <td className="px-5 py-3.5"><div className="text-white font-medium">{p.full_name}</div><div className="text-xs text-slate-500 flex items-center gap-1"><Building2 className="w-3 h-3" /> {p.company}</div></td>
                    <td className="px-5 py-3.5 hidden sm:table-cell text-slate-600">{p.host_email}</td>
                    <td className="px-5 py-3.5 hidden md:table-cell text-slate-500 text-xs font-mono">{new Date(p.issued_at).toLocaleString()}</td>
                    <td className="px-5 py-3.5"><span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-semibold ${isExpired(p) ? "bg-red-50 text-red-600 border border-red-200" : "bg-teal-50 text-teal-700 border border-teal-200"}`}><Clock className="w-3 h-3" /> {isExpired(p) ? "Expired" : "Active"}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
